import { useEffect, useRef } from "react";
import { useFactDetailContext } from "../context";
import { getFactById } from "../../../../../services";

export const useFactDetail = (factId) => {
  const {
    factDetail,
    loading,
    error,
    fetchFactDetail,
  } = useFactDetailContext();

  const prevFactIdRef = useRef(null);

  useEffect(() => {
    if (!factId) {
      return;
    }

    // Only fetch if factId changed
    if (prevFactIdRef.current !== factId) {
      prevFactIdRef.current = factId;
      fetchFactDetail(factId);
    }
  }, [factId, fetchFactDetail]);

  return {
    factData: factDetail,
    loading,
    error,
    refetch: () => fetchFactDetail(factId),
  };
};

